import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription, fromEvent, merge } from 'rxjs';
import { Footer } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() isPreview: boolean = false;
  public currentLang: string = '';
  public footer: Footer = new Footer();
  public footerPathLogo: string = "";
  public onChangeLang$: Subscription = new Subscription();
  public footerAltLogo: string = "";
  public domainWebsite = environment.urlApi;
  private subscriptionMouseMove: Subscription = new Subscription();
  public showFooter = false;

  constructor(public helpersService: HelpersService,
              public nodeService: NodeService,
              private router: Router,
              public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (this.helpersService.isBrowser) {
       this.subscriptionMouseMove = merge(
                fromEvent(document, 'mousemove'),
                fromEvent(document, 'touchmove'),
            ).subscribe((event: Event)=> {
        if (!this.showFooter) {
          this.showFooter = true;
          this.subscriptionMouseMove.unsubscribe();
        }
      });
    }
    this.currentLang = this.helpersService.lang;
    if (!this.helpersService.isBrowser) {
      this.getFooter();
    }
    this.onChangeLang$ = this.helpersService.onChangeLang.subscribe(langCode => {
      this.getFooter();
    })
  }

  ngOnDestroy(): void {
    if (this.onChangeLang$ instanceof Subscription) {
      this.onChangeLang$.unsubscribe();
    }
  }

  private getFooter() {
    this.nodeService.getFooter(this.helpersService.langCodeApi, this.isPreview).subscribe((res: Footer) => {
      res.field_dettagli_partner[0].value = res.field_dettagli_partner[0].value.replaceAll('target="_blank"', `target="_blank" aria-label="partner-anchor"`);
      res.field_dettagli_partner[0].value = res.field_dettagli_partner[0].value.replaceAll('<img', `<img loading="lazy" aria-label="partner" class="my-1 image-custom" style="width: 100px;height: 40px;"`);
      res.field_dettagli_partner[0].value = res.field_dettagli_partner[0].value.replaceAll('src="/', `src="${this.domainWebsite}/`);
      this.footer = res;
      this.footer.field_link_social = [{
        "field_link_social": [{
          "value": "https:\/\/www.youtube.com\/"
        }],
        "field_nome_social": [{
          "value": "Youtube"
        }]
      }, {
        "field_link_social": [{
          "value": "https:\/\/www.twitter.com\/"
        }],
        "field_nome_social": [{
          "value": "X"
        }]
      }, {
        "field_link_social": [{
          "value": "https:\/\/www.facebook.com\/"
        }],
        "field_nome_social": [{
          "value": "Facebook"
        }]
      }]
      this.footerPathLogo = this.footer.field_logo_universita[0].url;
      this.footerAltLogo = this.footer.field_logo_universita[0].alt;
    }, err => {
      this.nodeService.showError(err);
    })
  }

  public closeHeader() {
    this.helpersService.menuHeaderOpenBS.next(false);
    this.helpersService.menuHeaderClickedIdBS.next("");
  }

}
